module.exports = __webpack_public_path__ + "static/header_bg_3-797dcf9f4eb5a6b2232a65f3efe78ad8.png";